<template>
  <div class="flex min-h-screen w-full flex-col justify-between pt-navbar-height">
    <AppNavigation />

    <main class="flex flex-1 flex-col">
      <NuxtPage @entry-loaded="setEntry" />
    </main>

    <AppFooter />
  </div>
</template>

<script lang="ts" setup>
import type { PageQuery } from '#gql'

const globals = await useInjectableGlobals().catch((error) => {
  throw createError({
    fatal: true,
    statusCode: error?.status ?? 500,
    message: error instanceof Error ? error.message : 'Couldn\'t fetch globals',
  })
})

const entry = ref<PageQuery['entry'] | undefined>(undefined)
const setEntry = (newEntry: PageQuery['entry']) => (entry.value = newEntry)

provide(GlobalsKey, globals)
provide(EntryInjectionKey, entry)

// Fetch the available languages to log them
// const { getAvailableLanguages } = useShopwareSwitchLocale()
// const langs = await getAvailableLanguages()
// console.log(langs)

// Switch the shopware locale before fetching the categories
const { locale } = useI18n()
const { switchShopwareLocale } = useShopwareSwitchLocale()
switchShopwareLocale()

// Fetch the categories
const { categories, categoriesTree, fetchCategories } = useCategories()
fetchCategories()

// Provide categories for child components
provide('categories', categories)
provide('categoriesTree', categoriesTree)

// Watch the locale and switch the shopware locale when it changes then fetch the categories
watch(
  locale,
  async () => {
    await switchShopwareLocale()
    fetchCategories()
  },
)
</script>
